import * as React from 'react';

type PhpJsType = {
  [x: string]: any;
};

export interface PhpJsWindow<PhpJs> extends Window {
  phpJs: PhpJs;
}

/**
 * This is currently reading directly from window.
 * This poor excuse of a hook hopes to see this promoted somewhere better...
 * *Really, this is just as legitimate and equivalent to the withPhpJs HoC
 */
export function usePhpJs<PhpJs = PhpJsType, Return = PhpJs>(
  callback: (a: PhpJs) => Return,
  global: {
    phpJs: PhpJs;
  } = window as PhpJsWindow<PhpJs>,
) {
  return callback(global.phpJs);
}

/**
 * HoC to pluck out and pass down data from phpJs
 */
export const withPhpJs =
  <PhpJs = PhpJsType, Return = PhpJs>(
    getPhpJs: (a: PhpJs) => Return,
    global: {
      phpJs: PhpJs;
    } = window as PhpJsWindow<PhpJs>,
  ) =>
  (component: React.ComponentType<any>): React.ComponentType<any> => {
    return props =>
      React.createElement(component, {...getPhpJs(global.phpJs), ...props});
  };
